var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editorBlogHeader",attrs:{"id":_vm.$helper.kebabCase(_vm.data.text)}},[_c('editor-header',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }